module.exports = __webpack_public_path__ + "static/red-curtain.673f3445.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/red-curtain.jpg
// module id = 196
// module chunks = 35783957827783 142784606200730